import { Box, Stack, Typography } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { IllustrationCheckCircle } from './IllustrationCheckCircle';
import { IllustrationClockCircle } from './IllustrationClockCircle';
import { IllustrationCloseCircle } from './IllustrationCloseCircle';

type PredefinedIcon = 'success' | 'error' | 'info';
type Icon = ReactElement | PredefinedIcon;
interface Props {
  icon?: Icon;
  title?: ReactNode;
  subtitle?: ReactNode;
  actionButtons?: ReactNode;
}

const ILLUSTRATIONS_ICONS_MAP = {
  success: (
    <IllustrationCheckCircle
      sx={{
        width: 94,
        height: 137,
      }}
      viewBox="0 0 94 137"
    />
  ),
  error: (
    <IllustrationCloseCircle
      sx={{
        width: 94,
        height: 137,
      }}
      viewBox="0 0 94 137"
    />
  ),
  info: (
    <IllustrationClockCircle
      sx={{
        width: 94,
        height: 137,
      }}
      viewBox="0 0 94 137"
    />
  ),
};

export const FlowCompletion = (props: Props) => {
  const { icon = 'success', title, subtitle, actionButtons } = props;
  return (
    <Box
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center">
      <Stack alignItems="center" textAlign="center" gap={4}>
        {typeof icon === 'string' ? ILLUSTRATIONS_ICONS_MAP[icon] : icon}
        <Stack gap={3} maxWidth={640} width="100%" paddingX={2.5}>
          <Stack alignItems={'center'} justifyContent={'center'} gap={2}>
            {typeof title === 'string' ? (
              <Typography variant="h3">{title}</Typography>
            ) : (
              title
            )}
            {typeof subtitle === 'string' ? (
              <Typography variant="body1">{subtitle}</Typography>
            ) : (
              subtitle
            )}
          </Stack>
          {actionButtons && <Box>{actionButtons}</Box>}
        </Stack>
      </Stack>
    </Box>
  );
};
